import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_753b7wy8: FaireBrandEntity = {
  token: "b_753b7wy8",
  type: "brand",
  name: "Laalee Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/bb87d72274038c65f196fd3b513bcf325c46b6dd2b03437c914c58bdcafef9cc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9873be299d0fb85241696f5c83f142a6ef2882771077168084de8fcbdd823a18.png",
  logoUrl:
    "https://cdn.faire.com/fastly/bb87d72274038c65f196fd3b513bcf325c46b6dd2b03437c914c58bdcafef9cc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9873be299d0fb85241696f5c83f142a6ef2882771077168084de8fcbdd823a18.png",
  location: "Lafayette, LA, USA",
  minimumOrderDollars: 75,
  rating: 4.9,
  reviewCount: 738,
  isInsider: true,
  description:
    "We pride ourselves on quick shipping, wonderful quality products, and great customer service! :) Inspired by brilliant color, vibrant fashion trends, and a deep passion to drive my own retail shop, laalee was launched in 2011 by me, Christy Boustany Mims, out of south Louisiana. My pieces have been worn by many bridal parties, brides, and even celebrities. The jewelry does great with my wholesale clients as it makes for great gifts - anniversaries, weddings, Christmas, graduations, or just because!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:44.534Z",
    importedBy: "entity-db-cli",
  },
};
